import { Component, OnInit, inject } from '@angular/core';
import { IStation, DepartureMonitorService } from '../departure-monitor.service';
import { ModalController, IonicModule } from '@ionic/angular';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

import { TranslatePipe } from '@ngx-translate/core';
import { AppState } from 'src/app/app.module';
import { settingsFeature } from 'src/app/ngrx/settings/settings.feature';
import { SettingsActions } from 'src/app/ngrx/settings/settings.actions';

@Component({
    selector: 'app-stations',
    templateUrl: './stations.page.html',
    styleUrls: ['./stations.page.scss'],
    imports: [IonicModule, TranslatePipe]
})
export class StationsPage implements OnInit {
  private departureService = inject(DepartureMonitorService);
  private modalController = inject(ModalController);
  private store = inject<Store<AppState>>(Store);

  public stations: IStation[] = [];
  private rememberStation: boolean = true;
  private station: Observable<{ remember: boolean; rememberedId: string | null }>;

  constructor() {
    this.station = this.store.pipe(select(settingsFeature.selectDepartureStation));
  }

  ngOnInit() {
    this.departureService.stations().subscribe(stations => {
      this.stations = stations;
    });
    this.station.subscribe((station: { remember: boolean; rememberedId: string | null }) => {
      this.rememberStation = station.remember;
    });
  }

  public dismiss(station?: IStation) {
    if (station && this.rememberStation) {
      this.store.dispatch(SettingsActions.changeRememberedStation({ stationId: station.id }));
    }
    this.modalController.dismiss(station);
  }
}
